import { render, staticRenderFns } from "./ModificationsList.vue?vue&type=template&id=555938dc&scoped=true&"
import script from "./ModificationsList.vue?vue&type=script&lang=js&"
export * from "./ModificationsList.vue?vue&type=script&lang=js&"
import style0 from "./ModificationsList.vue?vue&type=style&index=0&id=555938dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555938dc",
  null
  
)

export default component.exports